(() => {
  if (!customElements.get('al-banner-carousel')) {
    customElements.define('al-banner-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-banner-track]');
        this.slides = [...this.querySelectorAll('[data-banner-slide]')];
        this.dots = [...this.querySelectorAll('[data-banner-dot]')];
        if (!this.track || !this.slides.length) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.index = 0;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reduced.matches;
        this.querySelector('[data-banner-prev]')?.addEventListener('click', () => this.go(this.index - 1), options);
        this.querySelector('[data-banner-next]')?.addEventListener('click', () => this.go(this.index + 1), options);
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i), options));
        this.pauseButton = this.querySelector('[data-banner-pause]');
        this.pauseButton?.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.restart(); }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.restart(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.restart(); }, options);
        this.addEventListener('focusin', () => this.restart(), options);
        this.addEventListener('focusout', () => setTimeout(() => this.restart(), 0), options);
        document.addEventListener('visibilitychange', () => this.restart(), options);
        this.reduced.addEventListener('change', () => { if (this.reduced.matches) this.paused = true; this.updatePause(); this.restart(); }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update(Math.round(this.track.scrollLeft / this.track.clientWidth)));
        }, options);
        this.resize = new ResizeObserver(() => this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' }));
        this.resize.observe(this.track);
        this.update(0); this.updatePause(); this.restart();
      }
      updatePause() {
        this.pauseButton?.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton?.setAttribute('aria-label', this.paused ? 'Reproduzir banners' : 'Pausar banners');
        const path = this.pauseButton?.querySelector('path');
        path?.setAttribute('d', this.paused ? 'm9 5 10 7-10 7z' : 'M9 6v12M15 6v12');
      }
      update(index) {
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.dots.forEach((dot, i) => i === this.index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
        this.slides.forEach((slide, i) => { slide.inert = i !== this.index; slide.setAttribute('aria-hidden', String(i !== this.index)); });
      }
      go(index) {
        const next = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: next * this.track.clientWidth, behavior: this.reduced.matches ? 'instant' : 'smooth' });
        this.restart();
      }
      restart() {
        clearInterval(this.timer);
        if (!this.paused && !this.reduced.matches && !this.hovered && !this.contains(document.activeElement) && !document.hidden && this.slides.length > 1)
          this.timer = setInterval(() => this.go(this.index + 1), 7000);
      }
      disconnectedCallback() { clearInterval(this.timer); cancelAnimationFrame(this.frame); this.abort?.abort(); this.resize?.disconnect(); }
    });
  }
  if (!customElements.get('al-collection-browser')) {
    customElements.define('al-collection-browser', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[role="tabpanel"]')];
        const select = (index, focus) => {
          tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
          panels.forEach((panel, i) => { panel.hidden = i !== index; });
          if (focus) tabs[index]?.focus({ preventScroll: true });
        };
        tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => select(i, false), { signal: this.abort.signal });
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); select(next, true); }
          }, { signal: this.abort.signal });
        });
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
})();